<template>
  <div>
    <Header />

    <div class="category-container">
      <h3 class="header-font blue-text" style="margin-bottom: 5px;">CHOOSE A CONTENT AREA</h3>
      <div class="row">
        <div class="col l3 m6 s12">

          <a href="/?category=Language%20Arts">
            <img src="/buttons/language-arts.png" style="width: 100%;" />
          </a>
        </div>
        <div class="col l3 m6 s12">

          <a href="/?category=Math">
            <img src="/buttons/math.png" style="width: 100%;" />
          </a>
        </div>
        <div class="col l3 m6 s12">

          <a href="/?category=Science">
            <img src="/buttons/science.png" style="width: 100%;" />
          </a>
        </div>
        <div class="col l3 m6 s12">

          <a href="/?category=Fine%20Arts">
            <img src="/buttons/music-arts.png" style="width: 100%;" />
          </a>
        </div>

      <div class="col l3 m6 s12">

          <a href="/?category=Social%20Studies">
            <img src="/buttons/social-studies.png" style="width: 100%;" />
          </a>
        </div>
        <div class="col l3 m6 s12">


          <a href="/?category=P.E.%20%26%20Health">
            <img src="/buttons/pe.png" style="width: 100%;" />
          </a>
        </div>
        <div class="col l3 m6 s12">

          <a href="/?category=Career%20%26%20Tech">
            <img src="/buttons/career.png" style="width: 100%;" />
          </a>
        </div>
        <div class="col l3 m6 s12">

          <a href="/?category=World%20Languages">
            <img src="/buttons/world-languages.png" style="width: 100%;" />
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col l3 m6 s12">
      <h3
        class="header-font blue-text hide-on-small-only"
        style="margin-top: 2%; margin-bottom: 5px"> 
		OR BROWSE THE RESOURCES</h3>
    </div>

    <!--  <div class="col l3 m6 s12">
      <div class='right-align' style='margin-top: 3%;'>
       <a href='https://apps.powerapps.com/play/e/default-883957d5-03cb-411a-a6cb-d272a5ad80c6/a/c3be0b26-dce8-4fca-be2f-e9fccda0e1a7?tenantId=883957d5-03cb-411a-a6cb-d272a5ad80c6&hint=0a1ee7e7-d63f-4855-b949-8f683aa26e7b&sourcetime=1785763211024' target='_blank'>
        <button class='btn blue white-text'> REQUEST NEW RESOURCE </button>
        </a> 
      </div>
</div> -->

    </div>

    <div id="begin-all-listings"></div>
    <ScrollUpButton :scrollToID="'begin-all-listings'" />
    <div class="content-container">
      <AllListings />
    </div>

    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Catalog from "@/components/Catalog.vue";
import AllListings from "@/components/AllListings.vue";
import ScrollUpButton from "@/components/ScrollUpButton.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "home",
  components: {
    Header,
    Catalog,
    AllListings,
    ScrollUpButton,
    Footer,
  },
  data: () => {
    return {
      showUpButton: false,
    };
  },
  methods: {
    scrollToCards() {
      window.scrollTo({
        top: document.getElementById("begin-sticky").offsetTop,
        left: 0,
        behavior: "smooth",
      });
      console.log("scrolling to cards");
    },
  },
};
</script>

<style scoped>
.small-text {
  font-size: 12px;
}
.content-container {
  width: 80%;
}

.home-page-card {
  height: 200px;
}

.hover-card {
  transition: ease-in-out 0.4s;
}

.looking-for-card > .btn {
  margin: 5px;
}

.hover-card:hover {
  transform: scale(1.05);
  background-color: #4fc3f7;
  color: white;
}

.card-content > div > p {
  width: 100%;
  text-align: center;
}

/* .card-content > div:after {
    clear: both;
  } */

@media screen and (max-width: 768px) {
  .content-container {
    width: 90%;
  }
}
</style>
